import {
  PickupOrderAlertStageEnum,
  type PickupOrderAlertType,
} from '@/types/order-alerts.types'

const ORDER_ALERTS_POLL_MS = 30 * 1000
const NOTIFIED_ALERTS_STORAGE_KEY = 'pickup-order-alert-notifications'

function getAlertIdentity(alert: PickupOrderAlertType) {
  return `${alert.orderId}:${alert.stage}`
}

function isConfirmAlert(alert: PickupOrderAlertType) {
  return (
    alert.stage === PickupOrderAlertStageEnum.CONFIRM_READY ||
    alert.stage === PickupOrderAlertStageEnum.CONFIRM_PICKED_UP
  )
}

function isReadyAlert(alert: PickupOrderAlertType) {
  return (
    alert.stage === PickupOrderAlertStageEnum.REMIND_READY ||
    alert.stage === PickupOrderAlertStageEnum.CONFIRM_READY
  )
}

function readNotifiedAlertIds(): string[] {
  try {
    const raw = localStorage.getItem(NOTIFIED_ALERTS_STORAGE_KEY)
    if (!raw) return []
    return JSON.parse(raw) as string[]
  } catch {
    return []
  }
}

function writeNotifiedAlertIds(ids: string[]) {
  localStorage.setItem(NOTIFIED_ALERTS_STORAGE_KEY, JSON.stringify(ids))
}

export {
  getAlertIdentity,
  isConfirmAlert,
  isReadyAlert,
  ORDER_ALERTS_POLL_MS,
  readNotifiedAlertIds,
  writeNotifiedAlertIds,
}
